// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/style/fonts.css'
import './scss/_main.scss'
import 'mobiotics-dynamic-graph-vue/dist/mobiotics-dynamic-graph-vue.css'
import { configClass } from './modules/appConfig.js';
Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue()

/* eslint-disable no-new */
async function initializeApp() {
  await new configClass().loadConfig()
  const store = (await import('./store/index.js')).default
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
}
initializeApp()



// var myHeaders = new Headers();
// myHeaders.append("authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InNyaWthbnRoIiwibG9nbyI6Imh0dHBzOi8vZDI3a3ZzYWpieWx1cXUuY2xvdWRmcm9udC5uZXQvcHJvdmlkZXIvbWFuaXNoa3IvdHNkME5zclouanBlZyIsInByb3ZpZGVyaWQiOiJtYW5pc2hrciIsImlwYWRkcmVzcyI6IjEwMy41LjEzNS43MiIsImlhdCI6MTU5MzQxMDk3NCwiZXhwIjoxNTkzNDE4MTc0LCJpc3MiOiJZZUd4Z0k2dyJ9.VMI-uQehgqFkeXNg4cJhBaC6IlfDp97IIghYK1GDYDs");

// var requestOptions = {
//   method: 'GET',
//   headers: myHeaders
// };

//   //var yyy = 'curl -v -X OPTIONS https://akwtu5b1z2.execute-api.us-east-1.amazonaws.com/beta/device/v1/register/encrypt'

// fetch("https://vtranscodestaging.mobiotics.com/provider/v1/preprocess", requestOptions)
//   .then(response => response.text())
//   .then(result => console.log(result))
//   .catch(error => console.log('error', error));


// WEBPACK FOOTER //
// ./src/main.js